import React, { useState, useEffect, useMemo } from 'react';
import { Col, Row, Label, Button } from 'reactstrap';
import Loader from '../../Components/Common/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { update_bot_details } from '../../slices/thunks';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../config';

const Bot_Instruction = () => {
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading } = useSelector((state) => state.BotDetails);
  const dispatch = useDispatch();

  const [bot_instruction, setbot_instruction] = useState('');

  const {
    Bot_ID,
    Bot_Instructions,
    User_Role,
  } = BotDetails || {};

  useEffect(() => {
    setbot_instruction(Bot_Instructions || '');
  }, [BotDetails, Bot_Instructions]);

  const readOnly = useMemo(() => (User_Role === 'BotUser' || User_Role === 'Viewer'), [User_Role]);

  const onClickSave_BotConfig = () => {
    dispatch(update_bot_details({
      Bot_ID: Bot_ID,
      instructions: bot_instruction, // already HTML from TinyMCE
    }));
  };

  return (
    <>
      <div className="mt-5">
        <div className='ws-fb' style={{ textAlign: 'right' }}>
          <Button onClick={onClickSave_BotConfig}>Save</Button>
        </div>

        <div className='bot_instruction_wrap border-padding'>
          <Row>
            <Col xxl={12} md={12}>
              <div className="mt-3 calc-height">
                <Label htmlFor="botinstruction" className="form-label">
                  Bot instruction
                </Label>

                {loading ? (
                  <Loader />
                ) : (
                  <Editor
                    id="botinstruction"
                    apiKey={config.api.tiny_mce_api_key}
                    value={bot_instruction}
                    onEditorChange={(content) => setbot_instruction(content)}
                    
                init={{
                  branding:false,
                  height: "95%",
                  resize: false,
                  menubar: false,
                  plugins: [
                    'advlist',
                    'autolink',
                    'lists',
                    'link',
                    'image',
                    'charmap',
                    'anchor',
                    'searchreplace',
                    'visualblocks',
                    'code',
                    'fullscreen',
                    'insertdatetime',
                    'media',
                    'table',
                    'preview',
                    'help',
                    'wordcount',
                  ],
                  toolbar:
                    'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                  content_style:
                    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                }}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Bot_Instruction;
